import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Municipio } from '../../../../types/Municipio.type';

@Injectable({
  providedIn: 'root'
})
export class MunicipiosService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll() {
    return this.httpClient.get<Municipio[]>(this.configService.getApiUrlRoot() + "/municipios/");
  }

  exportar(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/municipios/relatorios/exportar`, { responseType: 'blob' })
  }

}
